"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActionApi = exports.UserActionApiFactory = exports.UserActionApiFp = exports.UserActionApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
const common_1 = require("../common");
const base_1 = require("../base");
const UserActionApiAxiosParamCreator = function (configuration) {
    return {
        esyoilAPIEntryPointsUserActionAddDeliveryAddress: async (nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options = {}) => {
            const localVarPath = `/v1/user/@me/delivery-addresses/add`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (nameGiven !== undefined) {
                localVarFormParams.set('name_given', nameGiven);
            }
            if (nameFamily !== undefined) {
                localVarFormParams.set('name_family', nameFamily);
            }
            if (addressStreet !== undefined) {
                localVarFormParams.set('address_street', addressStreet);
            }
            if (addressZipcode !== undefined) {
                localVarFormParams.set('address_zipcode', addressZipcode);
            }
            if (addressLocation !== undefined) {
                localVarFormParams.set('address_location', addressLocation);
            }
            if (_default !== undefined) {
                localVarFormParams.set('default', _default);
            }
            if (company !== undefined) {
                localVarFormParams.set('company', company);
            }
            if (addressPhone !== undefined) {
                localVarFormParams.set('address_phone', addressPhone);
            }
            if (addressMobile !== undefined) {
                localVarFormParams.set('address_mobile', addressMobile);
            }
            if (addressEmail !== undefined) {
                localVarFormParams.set('address_email', addressEmail);
            }
            if (honorific !== undefined) {
                localVarFormParams.set('honorific', honorific);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionChangePassword: async (oldPassword, newPassword, options = {}) => {
            const localVarPath = `/v1/user/password-change`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (oldPassword !== undefined) {
                localVarFormParams.set('oldPassword', oldPassword);
            }
            if (newPassword !== undefined) {
                localVarFormParams.set('newPassword', newPassword);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionChangePasswordFinish: async (token, password, options = {}) => {
            const localVarPath = `/v1/user/password-change-finalize`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (token !== undefined) {
                localVarFormParams.set('token', token);
            }
            if (password !== undefined) {
                localVarFormParams.set('password', password);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionDeleteDeliveryAddress: async (cid, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsUserActionDeleteDeliveryAddress', 'cid', cid);
            const localVarPath = `/v1/user/@me/delivery-addresses/{cid}/delete`
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionDeleteUser: async (options = {}) => {
            const localVarPath = `/v1/user/@me/delete-me`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionGetDeliverAddresses: async (options = {}) => {
            const localVarPath = `/v1/user/@me/delivery-addresses`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionGetDeliveryAddress: async (cid, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsUserActionGetDeliveryAddress', 'cid', cid);
            const localVarPath = `/v1/user/@me/delivery-addresses/{cid}`
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionGetPreisaktion: async (deviceId, options = {}) => {
            const localVarPath = `/v1/user/notifications/get`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount: async (email, zipcode, options = {}) => {
            const localVarPath = `/v1/user/preisaktionWithoutAccount/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            if (zipcode !== undefined) {
                localVarFormParams.set('zipcode', zipcode);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount: async (email, zipcode, price, amount, ups, options = {}) => {
            const localVarPath = `/v1/user/preisweckerWithoutAccount/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            if (zipcode !== undefined) {
                localVarFormParams.set('zipcode', zipcode);
            }
            if (price !== undefined) {
                localVarFormParams.set('price', price);
            }
            if (amount !== undefined) {
                localVarFormParams.set('amount', amount);
            }
            if (ups !== undefined) {
                localVarFormParams.set('ups', ups);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionPatchDeliveryAddress: async (cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsUserActionPatchDeliveryAddress', 'cid', cid);
            const localVarPath = `/v1/user/@me/delivery-addresses/{cid}/patch`
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (nameGiven !== undefined) {
                localVarFormParams.set('name_given', nameGiven);
            }
            if (nameFamily !== undefined) {
                localVarFormParams.set('name_family', nameFamily);
            }
            if (addressStreet !== undefined) {
                localVarFormParams.set('address_street', addressStreet);
            }
            if (addressZipcode !== undefined) {
                localVarFormParams.set('address_zipcode', addressZipcode);
            }
            if (addressLocation !== undefined) {
                localVarFormParams.set('address_location', addressLocation);
            }
            if (_default !== undefined) {
                localVarFormParams.set('default', _default);
            }
            if (company !== undefined) {
                localVarFormParams.set('company', company);
            }
            if (honorific !== undefined) {
                localVarFormParams.set('honorific', honorific);
            }
            if (addressMobile !== undefined) {
                localVarFormParams.set('address_mobile', addressMobile);
            }
            if (addressPhone !== undefined) {
                localVarFormParams.set('address_phone', addressPhone);
            }
            if (addressEmail !== undefined) {
                localVarFormParams.set('address_email', addressEmail);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionResetPassword: async (email, options = {}) => {
            const localVarPath = `/v1/user/password-reset`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionSaveFallpreis: async (active, zip, amount, unloadingPoints, deviceId, options = {}) => {
            const localVarPath = `/v1/user/fallpreis/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (active !== undefined) {
                localVarFormParams.set('active', active);
            }
            if (zip !== undefined) {
                localVarFormParams.set('zip', zip);
            }
            if (amount !== undefined) {
                localVarFormParams.set('amount', amount);
            }
            if (unloadingPoints !== undefined) {
                localVarFormParams.set('unloadingPoints', unloadingPoints);
            }
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionSaveHeizoelvorrat: async (active, interval, deviceId, options = {}) => {
            const localVarPath = `/v1/user/fuellstand/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (active !== undefined) {
                localVarFormParams.set('active', active);
            }
            if (interval !== undefined) {
                localVarFormParams.set('interval', interval);
            }
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionSaveKauferinnerung: async (active, interval, zip, amount, unloadingPoints, deviceId, options = {}) => {
            const localVarPath = `/v1/user/kauferinnerung/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (active !== undefined) {
                localVarFormParams.set('active', active);
            }
            if (interval !== undefined) {
                localVarFormParams.set('interval', interval);
            }
            if (zip !== undefined) {
                localVarFormParams.set('zip', zip);
            }
            if (amount !== undefined) {
                localVarFormParams.set('amount', amount);
            }
            if (unloadingPoints !== undefined) {
                localVarFormParams.set('unloadingPoints', unloadingPoints);
            }
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionSavePreisaktion: async (zip, active, deviceId, options = {}) => {
            const localVarPath = `/v1/user/preisaktion/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (zip !== undefined) {
                localVarFormParams.set('zip', zip);
            }
            if (active !== undefined) {
                localVarFormParams.set('active', active);
            }
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionSavePreiswecker: async (zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options = {}) => {
            const localVarPath = `/v1/user/preiswecker/save`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (zip !== undefined) {
                localVarFormParams.set('zip', zip);
            }
            if (amount !== undefined) {
                localVarFormParams.set('amount', amount);
            }
            if (unloadingPoints !== undefined) {
                localVarFormParams.set('unloadingPoints', unloadingPoints);
            }
            if (productId !== undefined) {
                localVarFormParams.set('productId', productId);
            }
            if (price !== undefined) {
                localVarFormParams.set('price', price);
            }
            if (active !== undefined) {
                localVarFormParams.set('active', active);
            }
            if (isLoggedIn !== undefined) {
                localVarFormParams.set('isLoggedIn', isLoggedIn);
            }
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            if (receiveEmails !== undefined) {
                localVarFormParams.set('receiveEmails', receiveEmails);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionUpdateEmail: async (email, options = {}) => {
            const localVarPath = `/v1/user/@me/update-mail`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsUserActionUpdateEmailFinalize: async (token, options = {}) => {
            const localVarPath = `/v1/user/@me/update-mail-finalize`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (token !== undefined) {
                localVarFormParams.set('token', token);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UserActionApiAxiosParamCreator = UserActionApiAxiosParamCreator;
const UserActionApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.UserActionApiAxiosParamCreator(configuration);
    return {
        async esyoilAPIEntryPointsUserActionAddDeliveryAddress(nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionAddDeliveryAddress(nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionChangePassword(oldPassword, newPassword, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionChangePassword(oldPassword, newPassword, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionChangePasswordFinish(token, password, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionChangePasswordFinish(token, password, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionDeleteDeliveryAddress(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionDeleteDeliveryAddress(cid, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionDeleteUser(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionDeleteUser(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionGetDeliverAddresses(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionGetDeliverAddresses(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionGetDeliveryAddress(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionGetDeliveryAddress(cid, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionGetPreisaktion(deviceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionGetPreisaktion(deviceId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount(email, zipcode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount(email, zipcode, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount(email, zipcode, price, amount, ups, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount(email, zipcode, price, amount, ups, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionPatchDeliveryAddress(cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionPatchDeliveryAddress(cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionResetPassword(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionResetPassword(email, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionSaveFallpreis(active, zip, amount, unloadingPoints, deviceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionSaveFallpreis(active, zip, amount, unloadingPoints, deviceId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionSaveHeizoelvorrat(active, interval, deviceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionSaveHeizoelvorrat(active, interval, deviceId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionSaveKauferinnerung(active, interval, zip, amount, unloadingPoints, deviceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionSaveKauferinnerung(active, interval, zip, amount, unloadingPoints, deviceId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionSavePreisaktion(zip, active, deviceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionSavePreisaktion(zip, active, deviceId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionSavePreiswecker(zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionSavePreiswecker(zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionUpdateEmail(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionUpdateEmail(email, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsUserActionUpdateEmailFinalize(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsUserActionUpdateEmailFinalize(token, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.UserActionApiFp = UserActionApiFp;
const UserActionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.UserActionApiFp(configuration);
    return {
        esyoilAPIEntryPointsUserActionAddDeliveryAddress(nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionAddDeliveryAddress(nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionChangePassword(oldPassword, newPassword, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionChangePassword(oldPassword, newPassword, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionChangePasswordFinish(token, password, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionChangePasswordFinish(token, password, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionDeleteDeliveryAddress(cid, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionDeleteDeliveryAddress(cid, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionDeleteUser(options) {
            return localVarFp.esyoilAPIEntryPointsUserActionDeleteUser(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionGetDeliverAddresses(options) {
            return localVarFp.esyoilAPIEntryPointsUserActionGetDeliverAddresses(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionGetDeliveryAddress(cid, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionGetDeliveryAddress(cid, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionGetPreisaktion(deviceId, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionGetPreisaktion(deviceId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount(email, zipcode, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount(email, zipcode, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount(email, zipcode, price, amount, ups, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount(email, zipcode, price, amount, ups, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionPatchDeliveryAddress(cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionPatchDeliveryAddress(cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionResetPassword(email, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionResetPassword(email, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionSaveFallpreis(active, zip, amount, unloadingPoints, deviceId, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionSaveFallpreis(active, zip, amount, unloadingPoints, deviceId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionSaveHeizoelvorrat(active, interval, deviceId, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionSaveHeizoelvorrat(active, interval, deviceId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionSaveKauferinnerung(active, interval, zip, amount, unloadingPoints, deviceId, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionSaveKauferinnerung(active, interval, zip, amount, unloadingPoints, deviceId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionSavePreisaktion(zip, active, deviceId, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionSavePreisaktion(zip, active, deviceId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionSavePreiswecker(zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionSavePreiswecker(zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionUpdateEmail(email, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionUpdateEmail(email, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsUserActionUpdateEmailFinalize(token, options) {
            return localVarFp.esyoilAPIEntryPointsUserActionUpdateEmailFinalize(token, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserActionApiFactory = UserActionApiFactory;
class UserActionApi extends base_1.BaseAPI {
    esyoilAPIEntryPointsUserActionAddDeliveryAddress(nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionAddDeliveryAddress(nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, addressPhone, addressMobile, addressEmail, honorific, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionChangePassword(oldPassword, newPassword, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionChangePassword(oldPassword, newPassword, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionChangePasswordFinish(token, password, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionChangePasswordFinish(token, password, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionDeleteDeliveryAddress(cid, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionDeleteDeliveryAddress(cid, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionDeleteUser(options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionDeleteUser(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionGetDeliverAddresses(options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionGetDeliverAddresses(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionGetDeliveryAddress(cid, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionGetDeliveryAddress(cid, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionGetPreisaktion(deviceId, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionGetPreisaktion(deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount(email, zipcode, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionInsertNewPreisaktionWithoutAccount(email, zipcode, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount(email, zipcode, price, amount, ups, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionInsertNewPreisweckerWithoutAccount(email, zipcode, price, amount, ups, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionPatchDeliveryAddress(cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionPatchDeliveryAddress(cid, nameGiven, nameFamily, addressStreet, addressZipcode, addressLocation, _default, company, honorific, addressMobile, addressPhone, addressEmail, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionResetPassword(email, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionResetPassword(email, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionSaveFallpreis(active, zip, amount, unloadingPoints, deviceId, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionSaveFallpreis(active, zip, amount, unloadingPoints, deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionSaveHeizoelvorrat(active, interval, deviceId, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionSaveHeizoelvorrat(active, interval, deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionSaveKauferinnerung(active, interval, zip, amount, unloadingPoints, deviceId, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionSaveKauferinnerung(active, interval, zip, amount, unloadingPoints, deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionSavePreisaktion(zip, active, deviceId, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionSavePreisaktion(zip, active, deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionSavePreiswecker(zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionSavePreiswecker(zip, amount, unloadingPoints, productId, price, active, isLoggedIn, deviceId, receiveEmails, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionUpdateEmail(email, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionUpdateEmail(email, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsUserActionUpdateEmailFinalize(token, options) {
        return exports.UserActionApiFp(this.configuration).esyoilAPIEntryPointsUserActionUpdateEmailFinalize(token, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserActionApi = UserActionApi;
//# sourceMappingURL=user-action-api.js.map